import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import '../common/bn-surface';
import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

class NukeStorage extends LitElement {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 1em;
      }
      h1 {
        text-align: center;
        width: 50%;
      }
      bn-surface {
        width: 50%;
        text-align: center;
      }
      p a {
        margin: 1em 0 0 0;
        padding: 1em;
        display: inline-block;
      }
    `];
  }

  firstUpdated() {
    store.dispatch(storeActions.clear());
    store.dispatch(storeActions.navigate('/clear'));
  }

  render() {
    return html`
      <h1>BinSentry Storage Cleared</h1>
      <bn-surface>
        <p>
          You are now logged out & all storage for binsentry.com has been cleared.
          <br/>
          <a href="/login">Return to Login</a>
        </p>
      </bn-surface>
    `;
  }
}

customElements.define('nuke-storage', NukeStorage);
